var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "header" }, [
    _c(
      "div",
      { staticClass: "header__logo-container", class: _vm.modifierClass },
      [
        _c(
          "div",
          { staticClass: "header__logo" },
          [
            _c("router-link", { attrs: { to: "/dashboard" } }, [
              _c("img", {
                staticClass: "header__logo-img",
                attrs: {
                  src: "/images/fuel-logo.png",
                  alt: "Fuel Member Portal"
                }
              })
            ])
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "header__content-container",
        class: "header__content-container--" + _vm.modifierClass
      },
      [
        _c("div", { staticClass: "header__logo-angle-block" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header__content" },
          [
            _c(
              "span",
              {
                staticClass:
                  "header__section-indicator-icon h-display-inline-block"
              },
              [_c("i", { staticClass: "fa", class: _vm.icon })]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header__section-title h-display-inline-block" },
              [_vm._v(_vm._s(_vm.activeSectionObject.title))]
            ),
            _vm._v(" "),
            _vm.devEnv ? _c("VersionIndicator") : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header__member-menu-container",
            class: [
              { "header__end-container--hover": _vm.children.length },
              "header__member-menu-container--" + _vm.modifierClass
            ]
          },
          [
            _c(
              "div",
              {
                staticClass: "header__member-menu",
                class: [
                  { "header__end-container--hover": _vm.children.length },
                  "header__member-menu--" + _vm.modifierClass
                ]
              },
              [
                _vm.children.length
                  ? _c("ChildSelect")
                  : _c("div", {
                      staticClass: "header__member-name",
                      domProps: { innerHTML: _vm._s(_vm.memberName) }
                    })
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }